/**
 * Image extension with text-wrap: float left/right so text wraps around the image.
 * When an image is selected, use "Wrap left" / "Wrap right" / "No wrap" toolbar buttons.
 */
import Image from '@tiptap/extension-image';

const defaultImageAttributes = {
  src: { default: null },
  alt: { default: null },
  title: { default: null },
  width: { default: null },
  height: { default: null },
};

export const ImageWithWrap = Image.extend({
  addAttributes() {
    return {
      ...defaultImageAttributes,
      float: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-float') || null,
        renderHTML: (attributes) => {
          if (!attributes.float) return {};
          return { 'data-float': attributes.float };
        },
      },
    };
  },
});

export default ImageWithWrap;
